import 'flatpickr';
import { Arabic } from "flatpickr/dist/l10n/ar.js"


$(function () {

    $('.pure-material-textfield-outlined > input').change(function () {
        // console.log($(this).val())
        if ($(this).val() != "") {
            $(this).next().addClass('show-label')
        } else {
            $(this).next().removeClass('show-label')
        }
    })

    $('#close-drawer').click(function () {
        if ($('.mdl-layout__drawer-right').hasClass('is-visible')) {
            $('.mdl-layout__container').removeClass('overflow-hidden');
            $('.mdl-layout__drawer-right').removeClass('is-visible');
            $('#seat-reservation-drawer').removeClass('w-2/3');
            $('#root').hide()
            $('#seat-reservation-drawer').removeClass('left-auto');
            $('#seat-reservation-drawer').addClass('invisible');
        }
    });

    $('#collapse-content').hide()
    $('#collapsible').click(function () {
        $('#collapse-content').slideToggle();

        return false;
    });

    /** ADDITIONAL LUGGAGE START **/
    var trip_price = $('#items').data('trip-price');
    $("#add").click(function (e) {
        $(this).addClass('text-dark-blue')
        $(this).removeClass('bg-blue')
        $(this).removeClass('text-white')
        $(this).addClass('bg-dark-blue')
        $(this).addClass('white-spinner')
        $(this).addClass('cursor-not-allowed')
        $(this).attr('disabled', true)
        var _rows = $("#items").find(".row");
        var _nextIDX = _rows.length + 1;

        $.ajax({
            url: '/order/additional-luggage',
            type: "get",
            data: {
                'trip_price': trip_price,
                'trip_type': 'forth'
            },
            success: function (data) {
                $("#items").append(data);
                $("#items").children(".row:last-child").find('.numinput').prop('id', 'num' + _nextIDX);
                $("#items").children(".row:last-child").find('.total').prop('id', 'total-num' + _nextIDX);
                $("#items").children(".row:last-child").find('.extra-total').prop('id', 'extra-total-num' + _nextIDX);
                $("#items").children(".row:last-child").find('.numinputblock').addClass('hidden')
                $("#add").removeClass('text-dark-blue')
                $("#add").addClass('bg-blue')
                $("#add").addClass('text-white')
                $("#add").removeClass('bg-dark-blue')
                $("#add").removeClass('white-spinner')
                $("#add").removeClass('cursor-not-allowed')
                $("#add").attr('disabled', false)
            }
        })

    });
    $(".forth_trip").on('change', '.luggage-type', function (e) {
        var weight = $(this).find(":selected").data('weight');
        var height = $(this).find(":selected").data('height');
        var width = $(this).find(":selected").data('width');
        var length = $(this).find(":selected").data('length');
        var value = $(this).find(":selected").data('value');

        $(this).parents('.row').find('.luggage-data').removeClass('hidden')
        $(this).parents('.row').find('.luggage-data .weight').text(weight)
        $(this).parents('.row').find('.luggage-data .height').text(height)
        $(this).parents('.row').find('.luggage-data .width').text(width)
        $(this).parents('.row').find('.luggage-data .length').text(length)
        $(this).parents('.row:last-child').find('.numinputblock').removeClass('hidden');

        if ($(this).parents('.row').find('.numinputblock .numinput').data('value')) {
            $(this).parents('.row').find('.numinputblock .numinput').data('value', value)
        } else {
            $(this).parents('.row').find('.numinputblock .numinput').attr('data-value', value)
        }
        if ($(this).parents('.row').find('.numinputblock .numinput').val() == 0) {
            // console.log('herre');
            $(this).parents('.row').find('.numinputblock .forth-extra-symbol-plus').trigger("click");
        } else {
            // console.log('else');
            // console.log('----');
            $(this).parents('.row').find('.numinputblock .numinput').val(0)
            var total = parseFloat($(this).parents('.row').find('.total').text())
            var extra_total = parseFloat($('#total-extra-lugg-price').text());
            var cart_total = parseFloat($('#total-text').text());
            // console.log('totaal to remove => ', total);
            // console.log('extra totaal  => ', extra_total);
            // console.log('cart totaal  => ', cart_total);
            $(this).parents('.row').find('.total').text(0)
            $('#total-extra-lugg-price').text(parseFloat(extra_total - total))
            $('#total-text').text(parseFloat(cart_total - total))
            $(this).parents('.row').find('.numinputblock .forth-extra-symbol-plus').trigger("click");
        }
    });

    $('body').on('click', '.delete', function () {

        $(this).parents('.row').remove();
        // console.log('------ ');
        var numblock = $(this).parents('.row').find("input.numinput");
        var numid = $(numblock).attr("id");
        var extra_price = numblock.data('value');
        var total = parseFloat($('#total-text').text()) != 0 ? parseFloat($('#total-text').text()) : 0;
        var total = + parseFloat($('#total-text').text()) - extra_price;


        if ((parseFloat($('#total-extra-lugg-price').text()) - extra_price) > 0) {
            // console.log('-----');
            // console.log('here');

            if (parseFloat($('#first-total').text()) > 0) {
                // console.log('-----');
                // console.log('here if');
                if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                    var extra_total = 0;
                } else {
                    var extra_total = parseFloat($('#total-extra-lugg-price').text());
                }
                extra_total = parseFloat($('#first-total').text());
                $('#total-extra-lugg-price').text(extra_total)
                var total = parseFloat($('#total-text').text()) - parseFloat($(this).closest('.row').find('#total-' + numid).text());
                // console.log('this => ', $(this));
                // console.log('add => ', $(this).closest('.row').find('#total-'+numid).text());
                // console.log('extratot => ', extra_total);
                // console.log('after extratot => ', extra_total);
                // console.log('total => ', total);
                // console.log('extra_price => ', extra_price);
                $('#total-text').text(total);
                $('#cart-total').val($('#total-text').text());
            } else {
                // console.log('-----');
                // console.log('here else');
                if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {

                    var extra_total = 0;
                } else {
                    var extra_total = parseFloat($('#total-extra-lugg-price').text()) - parseFloat($(this).closest('.row').find('#total-' + numid).text());
                }
                var total = parseFloat($('#total-text').text()) - parseFloat($(this).closest('.row').find('#total-' + numid).text());
                $('#total-text').text(total);
                $('#cart-total').val($('#total-text').text());

                // console.log('extratot => ', extra_total);
                //extra_total = 0;
                // console.log('after extratot => ', extra_total);
                // console.log('total => ', total);
                // console.log('remved price => ', parseFloat($(this).closest('.row').find('#total-'+numid).text()));
                // console.log('lerngt => ', $("#items .row").length);
                $('#total-extra-lugg-price').text(extra_total)
                if (extra_total == 0 || $("#items .row").length == 0) {
                    $('.total-extra-lugg').addClass('hidden')
                }
                // $('#total-extra-lugg-price').text(($('#total-'+numid).text()))
            }
        } else {
            // console.log('-----');
            // console.log('else');
            $('#total-' + numid).text(parseFloat(0));
            $('#extra-total-' + numid).val($('#total-' + numid).text());

            $('#total-text').text(parseFloat($('#total-text').text()) - extra_price);
            $('#cart-total').val($('#total-text').text());
            if (parseFloat($('#first-total').text()) > 0) {
                if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                    var extra_total = 0;
                } else {
                    var extra_total = parseFloat($('#total-extra-lugg-price').text());
                }
                extra_total = extra_total - extra_price - parseFloat($('#first-total').text());
                $('#total-extra-lugg-price').text(extra_total)
            } else {
                // console.log('-----');
                $('.total-extra-lugg').addClass('hidden')
                if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                    var extra_total = 0;
                } else {
                    var extra_total = parseFloat($('#total-extra-lugg-price').text());
                }
                // console.log('extratot => ', extra_total);
                extra_total = extra_total - extra_price;
                // console.log('after extratot => ', extra_total);
                // console.log('total => ', total);
                // console.log('extra_price => ', extra_price);
                $('#total-extra-lugg-price').text(extra_total)
            }
        }
    })

    /** ADDITIONAL LUGGAGE END **/

    // First luggage qte start
    $("div#first-symbol-minus").click(function () {

        var numblock = $(this).parent().find("input.first_numinput");
        var extra_price = numblock.data('value');
        var cart_total = $('#total-text').text();
        var numid = $(numblock).attr("id");
        var num = $("#" + numid).val();
        $('#first-price' + (num - 1)).val(0);
        $('#first-price' + (num - 1)).remove();
        $('#first-number' + (num - 1)).remove();

        if (num == "") {
            console.log('heree');
            $("#" + numid).val(1);
        } else
            if (num > 0) {
                var total = parseFloat($('#total-text').text()) != 0 ? parseFloat($('#total-text').text()) : 0;
                var total = + parseFloat($('#total-text').text()) - extra_price;
                $('#total-text').text(parseFloat(total).toFixed(2));
                // $('#total-text').text(parseFloat($('#total-text').text()) - extra_price);                
                $('#cart-total').val($('#total-text').text());
                $("#" + numid).val(parseInt(num) - 1);
                if ((parseInt($('#first-total').text()) - extra_price) > 0) {
                    // console.log('----');
                    // console.log('first total => ', $('#first-total').text());
                    // console.log('first extra_price => ',extra_price);
                    $('#first-total').text(parseFloat($('#first-total').text()) - extra_price);
                    // $('#first-total').text(parseInt($('#total').text()) - extra_price);
                    $('#first-total').val($('#first-total').text());

                    $('#total-extra-lugg-price').text(($('#first-total').text()))
                } else {
                    // console.log('----');
                    // console.log('eelse first total => ', $('#first-total').text());
                    $('#first-total').text(parseInt(0));
                    $('#first-total').val($('#first-total').text());

                    // $('#total-text').text(parseInt($('#total-text').text()) - extra_price);                
                    // $('#cart-total').val($('#total-text').text());

                    if (parseInt($('#total').text()) > 0) {
                        $('#total-extra-lugg-price').text($('#total').text())
                    } else {
                        // console.log(parseFloat($('#total-extra-lugg-price').text()));
                        if (parseFloat($('#total-extra-lugg-price').text()) > 0 && $('#items .row').length > 0) {
                            // console.log('-----');
                            if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                                var extra_total = 0;
                            } else {
                                var extra_total = parseFloat($('#total-extra-lugg-price').text());
                            }
                            // console.log('extratot => ', extra_total);
                            extra_total = extra_total - extra_price;
                            // console.log('after extratot => ', extra_total);
                            // console.log('extra_price => ', extra_price);
                            // console.log('first => ', parseFloat($('#first-total').text()));
                            $('#total-extra-lugg-price').text(extra_total)
                            // $('#total-extra-lugg-price').text(parseFloat($('#total-extra-lugg-price').text()) - extra_price)
                        } else {
                            $('.total-extra-lugg').addClass('hidden')
                            $('#total-extra-lugg-price').text(($('#first-total').text()))
                        }
                    }
                }
            }
    });

    $("div#first-symbol-plus").click(function () {

        var numblock = $(this).parent().find("input.first_numinput");
        var extra_price = numblock.data('value');
        var cart_total = $('#total-text').text();
        var numid = $(numblock).attr("id");
        var max = $(numblock).attr("max");
        var num = $("#" + numid).val();
        if (num == "") {
            $("#" + numid).val(1);
            $('#first-total').text(extra_price);
        } else if (num < max) {
            $("#" + numid).val(parseInt(num) + 1);
            $('#first-total').text(parseFloat($('#first-total').text()) + extra_price);
            $('#first-total').val($('#first-total').text());

            $('#total-text').text(parseFloat($('#total-text').text()) + extra_price);
            $('#cart-total').val($('#total-text').text());

            $('.total-extra-lugg').removeClass('hidden')
            if (parseInt($('#total').text()) > 0) {
                // console.log('first here');
                $('#total-extra-lugg-price').text(parseFloat($('#total').text()) + parseFloat($('#first-total').text()))
            } else {
                // console.log('first eelse');
                // console.log(parseFloat($('#first-total').text()));
                if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                    var extra_total = 0;
                } else {
                    var extra_total = parseFloat($('#total-extra-lugg-price').text());
                }
                $('<input>').attr({
                    type: 'hidden',
                    id: 'first-price' + num,
                    name: 'passenger[' + num + '][forth_first_luggage_price]',
                    value: extra_price
                }).appendTo('#first-luggage-row')

                $('<input>').attr({
                    type: 'hidden',
                    id: 'first-number' + num,
                    name: 'passenger[' + num + '][forth_first_luggage_num]',
                    value: 1
                }).appendTo('#first-luggage-row')

                var extra_total = parseFloat($('#first-total').text());
                $('#total-extra-lugg-price').text(extra_total)
                // $('#total-extra-lugg-price').text($('#first-total').text())
            }
        }
    });
    // First luggage qte end

    // Extra luggage qte start
    $("body").on('click', '.forth-extra-symbol-minus', function () {

        var numblock = $(this).parent().find("input.numinput");
        var extra_price = numblock.data('value');
        var cart_total = $('#total-text').text();
        var numid = $(numblock).attr("id");
        $('#add-lugg-price-0').val(parseFloat(parseFloat($('#add-lugg-price-0').val()) - extra_price).toFixed(2))
        // $('#add-lugg-num-0').val(numblock.val())
        var num = $("#" + numid).val();
        if (num == "") { $("#" + numid).val(1); } else
            if (num > 0) {
                $("#" + numid).val(parseInt(num) - 1);
                if ((parseFloat($('#total-extra-lugg-price').text()) - extra_price) > 0) {
                    // console.log('-----');
                    // console.log('here');
                    $('#total-' + numid).text(parseFloat(parseFloat($('#total-' + numid).text()) - extra_price).toFixed(2));
                    $('#extra-total-' + numid).val($('#total-' + numid).text());

                    var total = parseFloat($('#total-text').text()) != 0 ? parseFloat($('#total-text').text()) : 0;
                    var total = + parseFloat($('#total-text').text()) - extra_price;
                    $('#total-text').text(parseFloat(total).toFixed(2));
                    // $('#total-text').text(parseFloat($('#total-text').text()) - extra_price);                
                    $('#cart-total').val($('#total-text').text());

                    if (parseFloat($('#first-total').text()) > 0) {
                        // console.log('-----');
                        // console.log('here if');
                        if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                            var extra_total = 0;
                        } else {
                            var extra_total = parseFloat($('#total-extra-lugg-price').text());
                        }
                        extra_total = extra_total - extra_price;
                        $('#total-extra-lugg-price').text(parseFloat(extra_total).toFixed(2))
                        // $('#total-extra-lugg-price').text(parseFloat($('#total-'+numid).text()) + parseFloat($('#first-total').text()))
                    } else {
                        // console.log('-----');
                        // console.log('here else');
                        if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                            var extra_total = 0;
                        } else {
                            var extra_total = parseFloat($('#total-extra-lugg-price').text());
                        }
                        // console.log('extratot => ', extra_total);
                        extra_total = extra_total - extra_price;
                        // console.log('after extratot => ', extra_total);
                        // console.log('total => ', total);
                        // console.log('extra_price => ', extra_price);
                        $('#total-extra-lugg-price').text(parseFloat(extra_total).toFixed(2))
                        // $('#total-extra-lugg-price').text(($('#total-'+numid).text()))
                    }
                } else {
                    // console.log('-----');
                    // console.log('else');
                    $('#total-' + numid).text(parseFloat(0));
                    $('#extra-total-' + numid).val($('#total-' + numid).text());

                    $('#total-text').text(parseFloat(parseFloat($('#total-text').text()) - extra_price).toFixed(2));
                    $('#cart-total').val($('#total-text').text());
                    if (parseFloat($('#first-total').text()) > 0) {
                        if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                            var extra_total = 0;
                        } else {
                            var extra_total = parseFloat($('#total-extra-lugg-price').text());
                        }
                        extra_total = extra_total - extra_price - parseFloat($('#first-total').text());
                        $('#total-extra-lugg-price').text(parseFloat(extra_total).toFixed(2))
                        // $('#total-extra-lugg-price').text(parseFloat($('#first-total').text()) - parseFloat($('#total-'+numid).text()))
                    } else {
                        // console.log('-----');
                        $('.total-extra-lugg').addClass('hidden')
                        //$('#total-extra-lugg').text('Extra luggage')
                        if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                            var extra_total = 0;
                        } else {
                            var extra_total = parseFloat($('#total-extra-lugg-price').text());
                        }
                        // console.log('extratot => ', extra_total);
                        extra_total = extra_total - extra_price;
                        // console.log('after extratot => ', extra_total);
                        // console.log('total => ', total);
                        // console.log('extra_price => ', extra_price);
                        $('#total-extra-lugg-price').text(parseFloat(extra_total).toFixed(2))
                        // $('#total-extra-lugg-price').text(($('#total-'+numid).text()))
                    }
                }
            }
        $('#add-lugg-num-0').val(parseInt($('#add-lugg-num-0').val()) - 1)
    });

    $("body").on('click', '.forth-extra-symbol-plus', function () {
        var numblock = $(this).parent().find("input.numinput");
        var extra_price = numblock.data('value');
        var cart_total = $('#total-text').text();
        var numid = $(numblock).attr("id");

        var num = $("#" + numid).val();
        if ($('#add-lugg-price-0').length > 0) {
            var val = parseFloat($('#add-lugg-price-0').val()).toFixed(2) + extra_price
            $('#add-lugg-price-0').val(parseFloat(parseFloat($('#add-lugg-price-0').val()) + extra_price).toFixed(2))
            // $('#add-lugg-num-0').val(numblock.val())
        } else {
            $('<input>').attr({
                type: 'hidden',
                id: 'add-lugg-price-0',
                name: 'passenger[0][forth_add_luggage_price]',
                value: extra_price
            }).appendTo($(this).parents('.row'))

            // console.log('numblock=> ', numblock);
            // console.log('forth_add_luggage_num=> ', numblock.val());
            $('<input>').attr({
                type: 'hidden',
                id: 'add-lugg-num-0',
                name: 'passenger[0][forth_add_luggage_num]',
                value: numblock.val()
            }).appendTo($(this).parents('.row'))
        }

        if (num == "") {
            $("#" + numid).val(1);
            $('#total-' + numid).text(extra_price);
        } else {
            $("#" + numid).val(parseInt(num) + 1);
            $('#total-' + numid).text(parseFloat(parseFloat($('#total-' + numid).text()) + extra_price).toFixed(2));
            // $('#total').text(parseFloat($('#total').text()) + extra_price);
            $('#extra-total-' + numid).val($('#total-' + numid).text());
            // $('#extra-total').val($('#total').text());

            var total = parseFloat($('#total-text').text()) != 0 ? parseFloat($('#total-text').text()) : 0;
            var total = + parseFloat($('#total-text').text()) + extra_price;
            $('#total-text').text(parseFloat(total).toFixed(2));
            $('#cart-total').val($('#total-text').text());

            $('.total-extra-lugg').removeClass('hidden')

            if ($('#first-total').length != 0 && $('#first-total').text() != '0') {
                // $('#total-extra-lugg-price').text(parseFloat($('#total-'+numid).text()) + parseFloat($('#first-total').text()))
                if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                    var extra_total = 0;
                } else {
                    var extra_total = parseFloat($('#total-extra-lugg-price').text());
                }
                extra_total = extra_total + extra_price;
                $('#total-extra-lugg-price').text(parseFloat(extra_total).toFixed(2))
            } else {
                // console.log('total => ', total);
                if (isNaN(parseFloat($('#total-extra-lugg-price').text()))) {
                    var extra_total = 0;
                } else {
                    var extra_total = parseFloat($('#total-extra-lugg-price').text());
                }
                // console.log('extratot => ', extra_total);
                extra_total = extra_total + extra_price;
                // console.log('after extratot => ', extra_total);
                // console.log('total => ', total);
                // console.log('extra_price => ', extra_price);
                $('#total-extra-lugg-price').text(parseFloat(extra_total).toFixed(2))
            }
        }
        if ($('#add-lugg-num-0').length > 0 && $('#add-lugg-num-0').val() != 0) {
            // console.log('if 0');
            var lugg = parseInt($('#add-lugg-num-0').val())
            $('#add-lugg-num-0').val(lugg + 1)
        } else {
            // console.log('else 0');
            $('#add-lugg-num-0').val(parseInt(numblock.val()))
        }
    });

    // Extra luggage qte end

    //passenger datepicker
    var lang = $('html').attr('lang') == 'ar' ? Arabic : '';
    // $('.datepicker').flatpickr({
    //     "locale": lang
    // })
    $('#birthdate').flatpickr({
        "locale": lang,
        maxDate: "today",
        disableMobile: "true",
    })
    var configs = [];
    $.ajax({
        url: '/configs',
        type: "get",
        async: false,
        success: function (data) {
            configs = data;
        }
    })
    var less_than_two = configs.filter(function (config) { return config.key == "age_discount_less_than_two" });
    var less_than_two_with_seat = configs.filter(function (config) { return config.key == "age_discount_less_than_two_with_seat" });
    var less_than_six = configs.filter(function (config) { return config.key == "age_discount_less_than_six" });
    var special_needs_discount = configs.filter(function (config) { return config.key == "special_needs_discount" });
    var companion_discount = configs.filter(function (config) { return config.key == "companion_discount" });
    var bookUnpaidWeb = configs.find(function (config) { return config.key == "bookUnpaidWeb" });
    sessionStorage.removeItem("age_discount");
    sessionStorage.removeItem("el_index");
    sessionStorage.removeItem('checked_seat');
    sessionStorage.removeItem("with_seat");
    sessionStorage.removeItem("adult");
    sessionStorage.removeItem('companion_index')
    sessionStorage.setItem("passengers", $('#seat-reservation-drawer').data('passengers'));


    if (!!bookUnpaidWeb && bookUnpaidWeb.value === "inactive") {
        $("#save-btn").removeClass('hidden')
    }

    $('.birthdate').flatpickr({
        "locale": lang,
        maxDate: "today",
        disableMobile: "true",
        onChange: [
            function (selectedDates, dateStr, instance) {
                $(this.element.nextElementSibling).css('opacity', 1)
                if ($('body').hasClass('order-page')) {
                    checkAge($(this.element), dateStr)
                }
            },
        ],
    })

    function checkAge(el, dateStr = NULL) {
        var age = moment().diff(dateStr, 'years');
        // console.log('saved index', sessionStorage['el_index']);
        var trip_price = parseFloat($('#forth-trip-price').data('trip-price'));
        // var trip_total = parseFloat($('#forth-trip-price').text());
        var trip_total = parseFloat($('#forth-trip-price').data('trip-total'));
        var back_trip_price = parseFloat($('#back-trip-price').data('trip-price'));
        var back_trip_total = parseFloat($('#back-trip-price').data('trip-total'));
        var passengers = $('#seat-reservation-drawer').data('passengers');
        var seats = $('#seat-reservation-drawer').data('seats')
        var discount = null;
        var index = el.data("index");
        $('#special-needs-row-' + index).removeClass('hidden');

        if (age <= 2 && (sessionStorage['age_discount'] == 'undefined' || sessionStorage['age_discount'] != 'less_than_two' || sessionStorage['age_discount'] == 'less_than_two' && index != sessionStorage['el_index'])) {

            /************* IF UNDER 2YO LOGIC / EXEC ONLY IF  ************* */

            $('.child-warning').removeClass('hidden'); // DISPLAY WARNING
            $('#companion-row-' + index).addClass('hidden'); // HIDE COMPANION CHECK
            el.parents('.passenger-block').find('#passenger[' + index + '][nin]').removeClass('required')
            el.parents('.passenger-block').find('#passenger[' + index + '][nin]').prop('required', false)

            /*** CALC DISCOUNTS  *** */
            var discount = trip_price * less_than_two[0].value / 100;
            var discount2 = trip_price * less_than_six[0].value / 100;
            var back_discount = back_trip_price * less_than_two[0].value / 100;
            var back_discount2 = trip_price * less_than_six[0].value / 100;

            /************    EXEC THE DISCOUNT IF DISCOUNT VALUE IS READY    ******** */
            if (less_than_two.length > 0) {
                if (parseFloat($('#forth-trip-price').text()) > 0) {
                    if (!el.data('discount') || el.data('discount') == 'more_than_six') {
                        $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) - discount);
                    } else if (el.data('discount') == 'less_than_six') {
                        $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + discount2 - discount);
                    }
                }

                if (el.data('discount') == 'less_than_six' || el.data('discount') == 'more_than_six') {
                    $('#seat-reservation-drawer').data('passengers', passengers - 1);
                }



                /********* IF THERE IS BACK TRIP ******** */
                if ($('#back-trip-price').length > 0) {
                    if (parseFloat($('#back-trip-price').text()) > 0) {
                        $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) - back_discount);
                    }

                    if (parseFloat($('#total-text').text()) > 0) {
                        $('#total-text').text(parseFloat($('#total-text').text()) - discount - back_discount);
                        $('#cart-total').val($('#total-text').text());
                    }
                } else {
                    if (parseFloat($('#total-text').text()) > 0) {
                        if (!el.data('discount') || el.data('discount') == 'more_than_six') {
                            $('#total-text').text(parseFloat($('#total-text').text()) - discount);

                        } else if (el.data('discount') == 'less_than_six') {
                            $('#total-text').text(parseFloat($('#total-text').text()) + discount2 - discount);
                        }
                        $('#cart-total').val($('#total-text').text());
                    }
                }

                /********** LOGIC TO DO WITH CHILD SEAT  ******** */
                if (less_than_two_with_seat.length > 0) {
                    if ($('#child-seat-' + index).prop('checked')) {
                        $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) - el.parents('.passenger-block').find('#child-seat-row-' + index).data('added-price'));
                        $('#total-text').text(parseFloat($('#total-text').text()) + - el.parents('.passenger-block').find('#child-seat-row-' + index).data('added-price'));
                        $('#cart-total').val($('#total-text').text());
                        $('#seat-reservation-drawer').data('passengers', passengers - 1);

                    }
                    el.parents('.passenger-block').find('#child-seat-row-' + index).removeClass('hidden'); //IF DISCOUNT VALUE IS READY
                    $('#child-seat-' + index).prop("checked", false); // UNCHECK CHILD SEAT VALUE IF IT IS CHECKED BEFORE AND WAS HIDDEN
                    el.parents('.passenger-block').find('#child-seat-row-' + index).data('added-price', trip_price * less_than_two_with_seat[0].value / 100);
                    console.log("222: ", el.parents('.passenger-block').find('#child-seat-row-' + index).data('added-price'))
                } // }

                if ($('#birthdate' + index).data('previous') > 0) {
                    $('#birthdate' + index).data('previous', $('#birthdate' + index).data('previous') - 1)
                }
                el.data('discount', 'less_than_two');
                sessionStorage.setItem("age_discount", 'less_than_two');
                sessionStorage.setItem("el_index", index);
                sessionStorage.setItem("with_seat", false);
                sessionStorage.setItem("adult", false); //console.log("less than two: ",el.data('discount'))

                if ($('#booking_policies').length > 0) {
                    if (!$('#booking_policies').prop("checked")) {//     $('#save-btn').removeAttr("disabled");
                        //     $('#save-btn').removeClass('cursor-not-allowed opacity-50');
                        //     $('#pay-btn').removeAttr("disabled");
                        //     $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
                        //     $('#pay-with-sadad').removeAttr("disabled");
                        //     $('#pay-with-sadad').removeClass('cursor-not-allowed opacity-50');
                        // }else{
                        // $('#pay-btn').attr('disabled', 'disabled');
                        // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                        // $('#save-btn').attr('disabled', 'disabled');
                        // $('#save-btn').addClass('cursor-not-allowed opacity-50');
                        // $('#pay-with-sadad').attr('disabled', 'disabled');
                        // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                    }
                } else {
                    //$('#seat-reservation-drawer').data('passengers', passengers - 1);
                    $('#pay-btn').attr('disabled', 'disabled');
                    $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                    $('#save-btn').attr('disabled', 'disabled');
                    $('#save-btn').addClass('cursor-not-allowed opacity-50');
                    $('#pay-with-sadad').attr('disabled', 'disabled');
                    $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                }
            }
        } else if (age > 2 && age <= 6 && (sessionStorage['age_discount'] == 'undefined' || sessionStorage['age_discount'] != 'less_than_six' || sessionStorage['age_discount'] == 'less_than_six' && index != sessionStorage['el_index'])) {

            /*************** BETWEEN 6 & 2 LOGIC  *********** */
            $('.child-warning').removeClass('hidden'); // REMOVE CHILD WARNING CSS
            $('#companion-row-' + index).addClass('hidden'); // REMOVE COMPANION ROW 


            var check = $('#birthdate' + index).data('previous'); // CHECK IF THIS ELEMENT IS ALREADY HAS BETWENN 6 & 2 AGE


            var discount = trip_price * less_than_six[0].value / 100;
            var back_discount = back_trip_price * less_than_six[0].value / 100;

            if (less_than_six.length > 0 && check < 1) {

                if (!el.parents('.passenger-block').find('#child-seat-row-' + index).hasClass('hidden')) {
                    $('#passenger[' + index + '][nin]').addClass('required')
                    /**********  IF THIS ELEMENT WAS LESS THAN 2 ******** */
                    var added = el.parents('.passenger-block').find('#child-seat-row-' + index).data('added-price');
                    el.parents('.passenger-block').find('#child-seat-row-' + index).addClass('hidden');

                    if ($('#child-seat-' + index).prop('checked')) {
                        /*********** IF THE CHILD SEAT WAS SELECTED  ******* */
                        $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + discount - added);
                        if ($('#back-trip-price').length > 0) {
                            $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) + back_discount - added);
                            $('#total-text').text(parseFloat($('#total-text').text()) + discount + back_discount - added);
                            $('#cart-total').val($('#total-text').text());
                        } else {
                            $('#total-text').text(parseFloat($('#total-text').text()) + discount - added);
                            $('#cart-total').val($('#total-text').text());
                        }


                        //$('#seat-reservation-drawer').data('passengers', passengers - 1); //SUB THE RESERVED SEAT FROM THE PREVIOUS PICK UNDER 2
                        $('#child-seat-' + index).prop("checked", false); //REMOVE THE CHECK FROM THE CHECKBOX
                        sessionStorage.removeItem("checked_seat_id");
                    } else {
                        $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + (trip_price - discount));

                        if ($('#back-trip-price').length > 0) {
                            $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) + (back_trip_price - back_discount));
                            $('#total-text').text(parseFloat($('#total-text').text()) + (trip_price - discount) + (back_trip_price - back_discount));
                            $('#cart-total').val($('#total-text').text());
                        } else {
                            $('#total-text').text(parseFloat($('#total-text').text()) + (trip_price - discount));
                            $('#cart-total').val($('#total-text').text());
                        }


                        $('#seat-reservation-drawer').data('passengers', passengers + 1); //ADD SEAT FROM THE PREVIOUS PICK UNDER 2 WITHOUT SEAT
                        sessionStorage.setItem("with_seat", true);


                    }
                } else {
                    /******** IF THE PREVIOUS ELE WAS DIFF THAN THIS ELE 2  ******** */
                    if (!el.data('discount')) {
                        $('#seat-reservation-drawer').data('passengers', passengers + 1); //ADD THE SEAT FROM THE PREVIOUS PICK IF SELECTED THE FIRST TIME OR FROM ANOTHER ELEMENT UNDER 2
                    }
                    if (parseFloat($('#forth-trip-price').text())) {
                        $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) - discount);
                    }

                    if ($('#back-trip-price').length > 0) {
                        $('#back-trip-price').text(back_trip_total - back_discount);
                        $('#total-text').text(parseFloat($('#total-text').text()) - discount - back_discount);
                        $('#cart-total').val($('#total-text').text());
                    } else {
                        $('#total-text').text(parseFloat($('#total-text').text()) - discount);
                        $('#cart-total').val($('#total-text').text());
                    }

                    //}
                } // }

                $('#birthdate' + index).data('previous', $('#birthdate' + index).data('previous') + 1)
                el.data('discount', 'less_than_six');
                sessionStorage.setItem("age_discount", 'less_than_six');
                sessionStorage.setItem("adult", false);
                sessionStorage.setItem("el_index", index); //console.log("less than 6:",el.data('discount'))

                if ($('#booking_policies').length > 0) {
                    if (!$('#booking_policies').prop("checked")) {// $('#pay-btn').attr('disabled', 'disabled');
                        // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                        // $('#save-btn').attr('disabled', 'disabled');
                        // $('#save-btn').addClass('cursor-not-allowed opacity-50');
                        // $('#pay-with-sadad').attr('disabled', 'disabled');
                        // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                    }
                } else {// $('#pay-btn').attr('disabled', 'disabled');
                    // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                    // $('#save-btn').attr('disabled', 'disabled');
                    // $('#save-btn').addClass('cursor-not-allowed opacity-50');
                    // $('#pay-with-sadad').attr('disabled', 'disabled');
                    // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                }

                $('#pay-btn').attr('disabled', 'disabled');
                $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                $('#save-btn').attr('disabled', 'disabled');
                $('#save-btn').addClass('cursor-not-allowed opacity-50');
                $('#pay-with-sadad').attr('disabled', 'disabled');
                $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
            }
        } else if (age > 6 && (sessionStorage['age_discount'] == 'undefined' || sessionStorage['age_discount'] != 'more_than_six' || sessionStorage['age_discount'] == 'more_than_six' && index != sessionStorage['el_index'])) {

            //******************** ACTIONS TO BE TAKEN IF HE IS 6 *********************** */


            $('.child-warning').removeClass('hidden'); // REMOVE CHILD WARNING
            $('#companion-row-' + index).addClass('hidden'); //HIDE COMPANION ROW




            /************ CHECK THE PREVIOUS DISCOUNT *********** */
            switch (el.data('discount')) {
                case 'less_than_two':
                    discount = trip_price * less_than_two[0].value / 100;

                    if ($('#back-trip-price').length > 0) {
                        back_discount = back_trip_price * less_than_two[0].value / 100;
                    }

                    break;

                case 'less_than_six':
                    discount = trip_price * less_than_six[0].value / 100;

                    if ($('#back-trip-price').length > 0) {
                        back_discount = back_trip_price * less_than_six[0].value / 100;
                    }

                    break;

                default:
                    discount = 0;
                    back_discount = 0;

            }

            /************ DIDNT FIND THIS USECASE YET!!!   *************** */
            if (age <= 2 || age <= 2 && !el.parents('.passenger-block').find('#child-seat-row-' + index).hasClass('hidden')) {
                console.log('6 wierd')
                // console.log('hiddne ', $('#child-seat-row-'+index).hasClass('hidden'));
                var added = el.parents('.passenger-block').find('#child-seat-row-' + index).data('added-price');
                el.parents('.passenger-block').find('#child-seat-row-' + index).addClass('hidden');
                $('#child-seat-' + index).prop("checked", false); //console.log("discount here <6 <=2", discount)

                $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + discount - added);

                if ($('#back-trip-price').length > 0) {
                    $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) + back_discount - added);
                    $('#total-text').text(parseFloat($('#total-text').text()) + discount + back_discount - added);
                    $('#cart-total').val($('#total-text').text());
                } else {
                    $('#total-text').text(parseFloat($('#total-text').text()) + discount - added);
                    $('#cart-total').val($('#total-text').text());
                } // sessionStorage.removeItem("checked_seat_id");
                // sessionStorage.setItem("with_seat",true);
                // $('#seat-reservation-drawer').data('passengers', passengers + 1 );

            } else {

                /*********** THE ELSE THAT WORK FROM THE WIERD PREVIOUS USECASE ************ */

                sessionStorage.setItem("with_seat", true);

                if ($('#child-seat-' + index).prop('checked')) {
                    /*************   IF THIS ELEMENT CHILD SEAT IS SELECTED    ***************/
                    $('#passenger[' + index + '][nin]').addClass('required')
                    var added = el.parents('.passenger-block').find('#child-seat-row-' + index).data('added-price');

                    $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + discount - added);

                    if ($('#back-trip-price').length > 0) {
                        $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) + back_discount - added);
                        $('#total-text').text(parseFloat($('#total-text').text()) + discount + back_discount - added);
                        $('#cart-total').val($('#total-text').text());
                    } else {
                        $('#total-text').text(parseFloat($('#total-text').text()) + discount - added);
                        $('#cart-total').val($('#total-text').text());
                    }
                    sessionStorage.removeItem("checked_seat_id");
                    sessionStorage.setItem("with_seat", false);
                } else {
                    if (!el.data('discount') || el.data('discount') == 'less_than_two') {
                        $('#seat-reservation-drawer').data('passengers', passengers + 1);
                    }
                    $('#passenger[' + index + '][nin]').addClass('required')
                    /***********  NO CHILD SEAT IS SELECTED ADD THE PREVIOUS SUB DISCOUNT   ******** */
                    $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + discount);

                    if ($('#back-trip-price').length > 0) {
                        $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) + back_discount);
                        $('#total-text').text(parseFloat($('#total-text').text()) + discount + back_discount);
                        $('#cart-total').val($('#total-text').text());
                    } else {
                        $('#total-text').text(parseFloat($('#total-text').text()) + discount);
                        $('#cart-total').val($('#total-text').text());
                    }



                }

                $('#child-seat-' + index).prop("checked", false);
                el.parents('.passenger-block').find('#child-seat-row-' + index).addClass('hidden');
            }


            if ($('#birthdate' + index).data('previous') > 0) {
                $('#birthdate' + index).data('previous', $('#birthdate' + index).data('previous') - 1)
            }
            el.data('discount', 'more_than_six');
            sessionStorage.setItem("age_discount", 'more_than_six');
            sessionStorage.setItem("el_index", index);

            /************ DO THIS LOGIC IS UNDER 13 ********** */

            if (age < 13) {
                $('.child-warning').removeClass('hidden');

                if ($('#booking_policies').length > 0) {
                    if (!$('#booking_policies').prop("checked")) {// $('#pay-btn').attr('disabled', 'disabled');
                        // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                        // $('#save-btn').attr('disabled', 'disabled');
                        // $('#save-btn').addClass('cursor-not-allowed opacity-50');
                        // $('#pay-with-sadad').attr('disabled', 'disabled');
                        // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                    }
                } else {// $('#pay-btn').attr('disabled', 'disabled');
                    // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                    // $('#save-btn').attr('disabled', 'disabled');
                    // $('#save-btn').addClass('cursor-not-allowed opacity-50');
                    // $('#pay-with-sadad').attr('disabled', 'disabled');
                    // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                } // $('#pay-btn').attr('disabled', 'disabled');
                // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                // $('#save-btn').attr('disabled', 'disabled');
                // $('#save-btn').addClass('cursor-not-allowed opacity-50');
                // $('#pay-with-sadad').attr('disabled', 'disabled');
                // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');


                sessionStorage.setItem("adult", false);
            } else {
                sessionStorage.setItem("adult", true); //console.log("done", index);
                if (seats > 1) {
                    $('#companion-row-' + index).removeClass('hidden');
                }
            }
        }

        var adult = $('.birthdate').filter(function () {
            var diff = moment().diff(this.value, 'years');
            return diff > 13;
        });
        var child = $('.birthdate').filter(function () {
            var diff = moment().diff(this.value, 'years');
            return diff < 13;
        }); // console.log('here child',child.length, adult)
        // console.log('here age',age)

        var atLeastOneIsChecked = $(".companion-row input[type=checkbox]:checked").length > 0;

        if (adult.length != 0) {
            //console.log("here is here")
            $('.child-warning').addClass('hidden'); //$('#companion-row-'+index).removeClass('hidden');
            //$('.companion-row').addClass('hidden')

            if (child.length > 0 && !atLeastOneIsChecked) {
                $('#booking_policies').prop("checked", false);
                $('#booking_policy').addClass('hidden')
                //el.parents('.passenger-block').find('#autofill-row').addClass('hidden'); 
                if ($('#booking_policies').length > 0) {
                    if (!$('#booking_policies').prop("checked")) {
                        $('#pay-btn').attr('disabled', 'disabled');
                        $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                        $('#save-btn').attr('disabled', 'disabled');
                        $('#save-btn').addClass('cursor-not-allowed opacity-50');
                        $('#pay-with-sadad').attr('disabled', 'disabled');
                        $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                    }
                } else {

                    $('#save-btn').attr("disabled");
                    $('#save-btn').addClass('cursor-not-allowed opacity-50');
                    $('#pay-btn').attr("disabled");
                    $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                    $('#pay-with-sadad').attr("disabled");
                    $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                }
            } else {
                if ($('#booking_policies').length > 0) {
                    $('#booking_policy').removeClass('hidden');
                    if (!$('#booking_policies').prop("checked")) {
                        $('#pay-btn').attr('disabled', 'disabled');
                        $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                        $('#save-btn').attr('disabled', 'disabled');
                        $('#save-btn').addClass('cursor-not-allowed opacity-50');
                        $('#pay-with-sadad').attr('disabled', 'disabled');
                        $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                    } else {
                        $('#booking_policy').removeClass('hidden');
                        el.parents('.passenger-block').find('#autofill-row').removeClass('hidden');
                        $('#save-btn').removeAttr("disabled");
                        $('#save-btn').removeClass('cursor-not-allowed opacity-50');
                        $('#pay-btn').removeAttr("disabled");
                        $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
                        $('#pay-with-sadad').removeAttr("disabled");
                        $('#pay-with-sadad').removeClass('cursor-not-allowed opacity-50');
                    }
                } else {
                    $('#booking_policy').removeClass('hidden');
                    el.parents('.passenger-block').find('#autofill-row').removeClass('hidden');
                    $('#save-btn').removeAttr("disabled");
                    $('#save-btn').removeClass('cursor-not-allowed opacity-50');
                    $('#pay-btn').removeAttr("disabled");
                    $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
                    $('#pay-with-sadad').removeAttr("disabled");
                    $('#pay-with-sadad').removeClass('cursor-not-allowed opacity-50');
                }
            }
        } else {
            $('#booking_policies').prop("checked", false);
            $('#booking_policy').addClass('hidden')
            $('#save-btn').attr("disabled");
            $('#save-btn').addClass('cursor-not-allowed opacity-50');
            $('#pay-btn').attr("disabled");
            $('#pay-btn').addClass('cursor-not-allowed opacity-50');
            $('#pay-with-sadad').attr("disabled");
            $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
            $('.child-warning').removeClass('hidden');

        } // if(age <= 13){
        //     // $('.child-warning').removeClass('hidden')
        //     el.parents('.passenger-block').find('#autofill-row').addClass('hidden')
        //     if($('#booking_policies').length > 0){
        //         if(!$('#booking_policies').prop("checked")){
        //             // $('#pay-btn').attr('disabled', 'disabled');
        //             // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
        //             // $('#save-btn').attr('disabled', 'disabled');
        //             // $('#save-btn').addClass('cursor-not-allowed opacity-50');
        //             // $('#pay-with-sadad').attr('disabled', 'disabled');
        //             // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
        //         }
        //     }else{
        //         // $('#pay-btn').attr('disabled', 'disabled');
        //         // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
        //         // $('#save-btn').attr('disabled', 'disabled');
        //         // $('#save-btn').addClass('cursor-not-allowed opacity-50');
        //         // $('#pay-with-sadad').attr('disabled', 'disabled');
        //         // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
        //     }
        //     // $('#save-btn').attr("disabled");
        //     // $('#save-btn').addClass('cursor-not-allowed opacity-50');
        //     // $('#pay-btn').attr("disabled");
        //     // $('#pay-btn').addClass('cursor-not-allowed opacity-50');
        //     // $('#pay-with-sadad').attr("disabled");
        //     // $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
        // }else{
        //     el.parents('.passenger-block').find('#autofill-row').removeClass('hidden')
        //     // $('.child-warning').addClass('hidden')
        // }


    }



    if ($('body').hasClass('order-page') && $('body').data('logged-user')) {
        var nationalities = []
        $.ajax({
            url: '/order/nationalities',
            type: "get",
            success: function (data) {
                var lang = $('html').attr('lang') == 'ar' ? 'ar' : 'en';
                nationalities = data;
                var maped = $.map(nationalities, function (item) {
                    return {
                        value: item.id,
                        label: lang == 'ar' ? item.country_arnationality : country_ennationality,
                    };
                })
                $(".nationalities").autocomplete({
                    source: maped,
                    minLength: 0,
                    select: function (event, ui) {
                        var index = $(this).data('index');
                        $(this).val(ui.item.label);
                        $(this).next().addClass('show-label');
                        $('input[name ="passenger[' + index + '][nationality]"]').val(ui.item.value);
                        maped = jQuery.grep(maped, function (element) {
                            return element.value != ui.item.value;
                        });
                        $('.nationalities').autocomplete('option', 'source', maped);
                        return false;
                    },
                }).focus(function () {
                    $(this).autocomplete("search");
                });
            }
        })
        // var nationalities = [];
        // $.ajax({
        //     url: '/order/nationalities',
        //     type: "get",
        //     success: function (data) {
        //         var index = $(this).data('index');
        //         nationalities = data;
        //         var maped = $.map(nationalities, function(item) {
        //             return {
        //                 id:item.id, 
        //                 arname: item.country_arnationality,
        //                 enname: item.country_ennationality
        //             };
        //         })
        //         $('input[name ="passenger['+index+'][nationality]"]').autocomplete({
        //                         source: maped,
        //                         minLength: 0,
        //                         select: function( event, ui ) {
        //                             $(this).val( ui.item.arname );
        //                             $(this).next().addClass('show-label');
        //                             return false;
        //                         }

        //         }).focus(function () {
        //             $(this).autocomplete("search");
        //         });
        //     }
        // })

        // $.ajax({
        //     url: '/order/passengers',
        //     type: "get",
        //     success: function (data) {
        //         passengers = data;
        //         var maped = $.map(passengers, function(item) {
        //             return {
        //                 value:item.id, 
        //                 label: item.firstname+" "+item.lastname, 
        //                 firstname: item.firstname, 
        //                 lastname: item.lastname, 
        //                 birthdate: item.birthdate, 
        //                 gender: item.gender,
        //                 nin:item.nin
        //             };
        //         })

        //         $( ".firstname" ).autocomplete({
        //             source: maped,
        //             minLength: 0,
        //             select: function( event, ui ) {
        //                 // console.log(maped);
        //                 var index = $(this).data('index');
        //                 $(this).val( ui.item.firstname );
        //                 $(this).next().addClass('show-label');

        //                 $('input[name ="passenger['+index+'][lastname]"]').val(ui.item.lastname);
        //                 $('input[name ="passenger['+index+'][lastname]"]').next().addClass('show-label');
        //                 $('input[name ="passenger['+index+'][lastname]"]').removeClass('border-red');

        //                 $('input[name ="passenger['+index+'][birthdate]"]').flatpickr({
        //                     defaultDate: ui.item.birthdate,
        //                     maxDate: "today",
        //                     onChange: [
        //                         function(selectedDates, dateStr, instance){
        //                             $(this.element.nextElementSibling).css('opacity',1)
        //                             if($('body').hasClass('order-page')){
        //                                 checkAge($(this.element), dateStr)
        //                             }
        //                         },
        //                     ],
        //                 });

        //                 $('input[name ="passenger['+index+'][birthdate]"]').next().addClass('show-label');
        //                 $('input[name ="passenger['+index+'][birthdate]"]').removeClass('border-red');

        //                 $('select[name ="passenger['+index+'][gender]"] option[value="'+ui.item.gender+'"]').attr('selected', true);
        //                 $('select[name ="passenger['+index+'][gender]"]').parent( ".mdl-selectfield" ).addClass('is-focused')

        //                 $('input[name ="passenger['+index+'][nin]"]').val(ui.item.nin);
        //                 $('input[name ="passenger['+index+'][nin]"]').next().addClass('show-label');
        //                 $('input[name ="passenger['+index+'][nin]"]').removeClass('border-red');

        //                 $('<input>').attr({
        //                     type: 'hidden',
        //                     name: 'passenger['+index+'][id]',
        //                     value: ui.item.value
        //                 }).appendTo('#pasenger-'+index+'-id');

        //                 maped = jQuery.grep(maped, function(element) {
        //                     return element.value != ui.item.value;
        //                 });   
        //                 $('.firstname').autocomplete('option', 'source', maped);

        //                 sessionStorage.removeItem("age_discount");
        //                 // console.log("dateee= ", ui.item.birthdate);
        //                 checkAge($('input[name ="passenger['+index+'][birthdate]"]'), ui.item.birthdate)


        //                 return false;
        //             },
        //         }).focus(function () {
        //             $(this).autocomplete("search");
        //         });
        //     }
        // })

        // function checkAmount(total) {
        // var balance = parseInt('{{ $logged_in_user->balance }}');
        // if(total > balance) {
        //     $('#pay-btn').attr('disabled', 'disabled');;
        //     $('#pay-btn').addClass('cursor-not-allowed opacity-50');
        // }else{
        //     $('#pay-btn').removeAttr("disabled");
        //     $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
        // }
        //}
        // CHILD SEATS
        $('body').on('click', '.child-seat', function () {
            var trip_price = parseFloat($('#forth-trip-price').data('trip-price'));
            var trip_total = parseFloat($('#forth-trip-price').data('trip-total'));
            var back_trip_price = parseFloat($('#back-trip-price').data('trip-price'));
            var back_trip_total = parseFloat($('#back-trip-price').data('trip-total'));
            var passengers = $('#seat-reservation-drawer').data('passengers');
            var seats = $('#seat-reservation-drawer').data('seats');
            var discount = trip_price * less_than_two_with_seat[0].value / 100;
            var back_discount = back_trip_price * less_than_two_with_seat[0].value / 100;
            if (less_than_two_with_seat.length > 0) {
                if ($(this).prop("checked")) {
                    $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + discount);

                    if ($('#back-trip-price').length > 0) {
                        $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) + back_discount);
                        $('#total-text').text(parseFloat($('#total-text').text()) + discount + back_discount);
                        $('#cart-total').val($('#total-text').text());
                    } else {
                        $('#total-text').text(parseFloat($('#total-text').text()) + discount);
                        $('#cart-total').val($('#total-text').text());
                    }

                    sessionStorage.setItem('checked_seat_id', $(this).attr('id'));
                    sessionStorage.setItem('with_seat', true);


                    $('#seat-reservation-drawer').data('passengers', passengers + 1);

                } else {
                    if (parseFloat($('#forth-trip-price').text()) > 0) {
                        $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) - discount);
                    }

                    if ($('#back-trip-price').length > 0) {
                        if (parseFloat($('#back-trip-price').text()) > 0) {
                            $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) - back_discount);
                        }

                        if (parseFloat($('#total-text').text()) > 0) {
                            $('#total-text').text(parseFloat($('#total-text').text()) - discount - back_discount);
                            $('#cart-total').val($('#total-text').text());
                        }
                    } else {
                        if (parseFloat($('#total-text').text()) > 0) {
                            $('#total-text').text(parseFloat($('#total-text').text()) - discount);
                            $('#cart-total').val($('#total-text').text());
                        }
                    }
                    sessionStorage.setItem('with_seat', false);
                    $('#seat-reservation-drawer').data('passengers', passengers - 1);
                    var index = $(this).parents('.passenger-block').find('.birthdate').data('index')
                    $('.forth-seat-checkbox:checked').each(function (e) {
                        if (e == index) {
                            $(this).prop("checked", false);
                            $(this).trigger("change");
                            return false;
                        }
                    });

                }
            }
        });

        // SPACIAL NEEDS
        // $('body').on('click', '.special-needs', function() {
        //     var trip_price = parseFloat($('#forth-trip-price').data('trip-price'));
        //     var back_trip_price = parseFloat($('#back-trip-price').data('trip-price'));
        //     var index = $(this).data('index');
        //     var checked = $('.special-needs').filter(function() {
        //         return $(this).prop("checked");
        //     });
        //     var passenger_birthdate = $('input[name ="passenger['+index+'][birthdate]"]').val();
        //     var passenger_age = moment().diff(passenger_birthdate, 'years');
        //     // console.log('age => ', passenger_age);
        //     // console.log('less_than_two value  => ', parseFloat(less_than_two[0].value));
        //     // console.log('special_needs_discount value  => ', parseFloat(special_needs_discount[0].value));
        //     // console.log('condition 1=> ', passenger_birthdate != '');
        //     // console.log('condition 2=> ',  parseFloat(special_needs_discount[0].value) > parseFloat(less_than_two[0].value));
        //     // console.log('condition 3=> ', passenger_age > 2 && passenger_age <= 6 && less_than_six.length > 0 && (special_needs_discount[0].value > less_than_six[0].value));
        //     // console.log('condition 4=> ', passenger_age > 6);
        //     if(special_needs_discount.length > 0){
        //         if (
        //             passenger_birthdate != '' && 
        //             (passenger_age <= 2 && less_than_two.length > 0 && (parseFloat(special_needs_discount[0].value) > parseFloat(less_than_two[0].value)))
        //             || (passenger_age > 2 && passenger_age <= 6 && less_than_six.length > 0 && (parseFloat(special_needs_discount[0].value) > parseFloat(less_than_six[0].value)))
        //             || (passenger_age > 6)
        //         ) {                
        //             var discount = (trip_price * special_needs_discount[0].value) / 100;
        //             var back_discount = (back_trip_price * less_than_two_with_seat[0].value) / 100;
        //             if($(this).prop("checked")) {
        //                 if(parseFloat($('#forth-trip-price').text()) > 0){
        //                     $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) - discount)
        //                 }
        //                 if($('#back-trip-price').length > 0){

        //                     if(parseFloat($('#back-trip-price').text()) > 0){
        //                         $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) - back_discount)
        //                     }
        //                     if(parseFloat($('#total-text').text()) > 0){
        //                         $('#total-text').text(parseFloat($('#total-text').text()) - discount - back_discount) 
        //                         $('#cart-total').val($('#total-text').text());
        //                     }
        //                 }else{
        //                     if(parseFloat($('#total-text').text()) > 0){
        //                         $('#total-text').text(parseFloat($('#total-text').text()) - discount)
        //                         $('#cart-total').val($('#total-text').text());
        //                     }
        //                 }
        //             }else{
        //                 // console.log('elseee => ', discount);
        //                 // console.log("forty => " , parseFloat($("#forth-trip-price").text()));
        //                 $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + discount)
        //                 if($('#back-trip-price').length > 0){
        //                     $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) + back_discount)
        //                     $('#total-text').text(parseFloat($('#total-text').text()) + discount + back_discount)
        //                     $('#cart-total').val($('#total-text').text());
        //                 }else{
        //                     $('#total-text').text(parseFloat($('#total-text').text()) + discount)
        //                     $('#cart-total').val($('#total-text').text());
        //                 }

        //             }
        //         }
        //     }

        // })

        // COMPANION
        $('body').on('click', '.companion', function () {
            var trip_price = parseFloat($('#forth-trip-price').data('trip-price'));
            var back_trip_price = parseFloat($('#back-trip-price').data('trip-price'));
            var index = $(this).data('index');
            var child = $('.birthdate').filter(function () {
                var diff = moment().diff(this.value, 'years');
                return diff <= 13;
            });
            var with_special_needs = $('#special-needs-' + index).prop("checked");
            var special_needs_passengers = $('.special-needs:checked').length;
            if (companion_discount.length > 0) {
                var discount = (trip_price * companion_discount[0].value) / 100;
                // console.log('companion_discount_value =', companion_discount[0].value);
            }
            // console.log('session index=> ', sessionStorage['companion_index']);
            // console.log('index=> ', index);

            $('.companion').not(this).prop('checked', false);
            // console.log('with_special_needs',with_special_needs);
            // console.log('companion_discount value= ',parseInt(companion_discount[0].value));
            // console.log('special_needs_discount value= ', parseInt(special_needs_discount[0].value));
            // console.log('condition 2',(parseInt(companion_discount[0].value) > parseInt(special_needs_discount[0].value)));
            // console.log('child.length',child.length);
            // console.log('child.length',child.length);
            // var passenger_age = moment().diff($('input[name ="passenger['+index+'][birthdate]"]').val(), 'years');
            // if(companion_discount.length > 0){
            if (
                (with_special_needs && (parseInt(companion_discount[0].value) > parseInt(special_needs_discount[0].value)))
                || (!with_special_needs && special_needs_passengers > 0)
                && child.length == 0

            ) {
                // if($('.companion:checked').length > 0 && (sessionStorage['companion_index'] != undefined && parseInt(sessionStorage['companion_index']) != index)){
                // console.log('iiiiiifff');
                //     $('#forth-trip-price').text(parseInt($('#forth-trip-price').text()) + discount)
                //     if($('#back-trip-price').length > 0){
                //         $('#back-trip-price').text(parseInt($('#back-trip-price').text()) + back_discount)
                //         $('#total-text').text(parseInt($('#total-text').text()) + discount + back_discount)
                //         $('#cart-total').val($('#total-text').text());
                //     }else{
                //         $('#total-text').text(parseInt($('#total-text').text()) + discount)
                //         $('#cart-total').val($('#total-text').text());
                //     }     
                // }  
                sessionStorage.setItem('companion_index', index);
                if ($(this).prop("checked")) {
                    if (parseFloat($('#forth-trip-price').text()) > 0) {
                        $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) - discount)
                    }
                    // console.log('price after discount', parseFloat($('#forth-trip-price').text()) - discount);
                    if ($('#back-trip-price').length > 0) {
                        var back_discount = (back_trip_price * less_than_two_with_seat[0].value) / 100;
                        if (parseFloat($('#back-trip-price').text()) > 0) {
                            $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) - back_discount)
                        }
                        if (parseFloat($('#total-text').text()) > 0) {
                            $('#total-text').text(parseFloat($('#total-text').text()) - discount - back_discount)
                            $('#cart-total').val($('#total-text').text());
                        }
                    } else {
                        if (parseFloat($('#total-text').text()) > 0) {
                            $('#total-text').text(parseFloat($('#total-text').text()) - discount)
                            $('#cart-total').val($('#total-text').text());
                        }
                    }
                } else {
                    $('#forth-trip-price').text(parseFloat($('#forth-trip-price').text()) + discount)
                    if ($('#back-trip-price').length > 0) {
                        $('#back-trip-price').text(parseFloat($('#back-trip-price').text()) + back_discount)
                        $('#total-text').text(parseFloat($('#total-text').text()) + discount + back_discount)
                        $('#cart-total').val($('#total-text').text());
                    } else {
                        $('#total-text').text(parseFloat($('#total-text').text()) + discount)
                        $('#cart-total').val($('#total-text').text());
                    }
                }
            } else if (child.length != 0) {
                if ($(this).prop("checked")) {
                    $('#booking_policy').removeClass('hidden')
                    if ($('#booking_policies').length > 0) {
                        if ($('#booking_policies').prop("checked")) {
                            $('#save-btn').removeAttr("disabled");
                            $('#save-btn').removeClass('cursor-not-allowed opacity-50');
                            $('#pay-btn').removeAttr("disabled");
                            $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
                            $('#pay-with-sadad').removeAttr("disabled");
                            $('#pay-with-sadad').removeClass('cursor-not-allowed opacity-50');
                        } else {
                            $('#pay-btn').attr('disabled', 'disabled');
                            $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                            $('#save-btn').attr('disabled', 'disabled');
                            $('#save-btn').addClass('cursor-not-allowed opacity-50');
                            $('#pay-with-sadad').attr('disabled', 'disabled');
                            $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                        }
                    } else {
                        $('#save-btn').removeAttr("disabled");
                        $('#save-btn').removeClass('cursor-not-allowed opacity-50');
                        $('#pay-btn').removeAttr("disabled");
                        $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
                        $('#pay-with-sadad').removeAttr("disabled");
                        $('#pay-with-sadad').removeClass('cursor-not-allowed opacity-50');
                    }
                    // $('#save-btn').removeAttr("disabled");
                    // $('#save-btn').removeClass('cursor-not-allowed opacity-50');
                    // $('#pay-btn').removeAttr("disabled");
                    // $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
                    // $('#pay-with-sadad').removeAttr("disabled");
                    // $('#pay-with-sadad').removeClass('cursor-not-allowed opacity-50');
                } else {
                    $('#booking_policies').attr("checked", false);
                    $('#booking_policy').addClass('hidden')
                    $('#save-btn').attr("disabled")
                    $('#save-btn').addClass('cursor-not-allowed opacity-50');
                    $('#pay-btn').attr("disabled");
                    $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                    $('#pay-with-sadad').attr("disabled");
                    $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                }
            }

            // }
        });


        if ($('#booking_policies').length > 0) {
            $('#booking_policy').addClass('hidden')
            if ($('#booking_policies').prop("checked")) {
                $('#save-btn').removeAttr("disabled");
                $('#save-btn').removeClass('cursor-not-allowed opacity-50');
                $('#pay-btn').removeAttr("disabled");
                $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
                $('#pay-with-sadad').removeAttr("disabled");
                $('#pay-with-sadad').removeClass('cursor-not-allowed opacity-50');
            } else {
                $('#pay-btn').attr('disabled', 'disabled');
                $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                $('#save-btn').attr('disabled', 'disabled');
                $('#save-btn').addClass('cursor-not-allowed opacity-50');
                $('#pay-with-sadad').attr('disabled', 'disabled');
                $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
            }

            $('body').on('click', '#booking_policies', function () {
                if ($(this).prop("checked")) {
                    $('#save-btn').removeAttr("disabled");
                    $('#save-btn').removeClass('cursor-not-allowed opacity-50');
                    $('#pay-btn').removeAttr("disabled");
                    $('#pay-btn').removeClass('cursor-not-allowed opacity-50');
                    $('#pay-with-sadad').removeAttr("disabled");
                    $('#pay-with-sadad').removeClass('cursor-not-allowed opacity-50');
                } else {
                    $('#pay-btn').attr('disabled', 'disabled');
                    $('#pay-btn').addClass('cursor-not-allowed opacity-50');
                    $('#save-btn').attr('disabled', 'disabled');
                    $('#save-btn').addClass('cursor-not-allowed opacity-50');
                    $('#pay-with-sadad').attr('disabled', 'disabled');
                    $('#pay-with-sadad').addClass('cursor-not-allowed opacity-50');
                }
            })
        }
        // seats
        if ($('#order-form').data('forth-trip') && !$('#order-form').data('back-trip')) {
            var $body = $('body');
            var limit = $('#seat-reservation-drawer').data('passengers');
            $('#seat-reservation').click(function (e) {
                limit = $('#seat-reservation-drawer').data('passengers');
                $('#limit-passengers').text(limit)
                e.preventDefault();
                var windowsize = $(window).width();
                if ($('.bus_layout').length == 0) {
                    $('#bus-layout').addClass('spinner');
                    $.ajax({
                        type: "get",
                        url: "/order/getFleetType",
                        data: {
                            round_trip: 'forth'
                        },
                        cache: false,
                        success: function (data) {
                            $('#bus-layout').removeClass('spinner');
                            $('#bus-layout').html(data)
                        }
                    });
                }
                $('#seat-reservation-drawer').addClass('is-visible');
                $('#seat-reservation-drawer').addClass('left-auto');
                $('.mdl-layout__drawer-right').addClass('is-visible');
                $('.mdl-layout__container').addClass('overflow-hidden');
                if (windowsize > 839) {
                    $('#seat-reservation-drawer').addClass('w-3/5')
                } else {
                    $('#seat-reservation-drawer').addClass('w-full')
                }
                $('#seat-reservation-drawer').removeClass('invisible')
                return false;
            });
            $(document).ready(function () {


                // console.log('---', limit);
                // console.log('limit', limit);
                $body.on('change', '.forth-seat-checkbox', function (e) {
                    var selectedSeats = $('.forth-seat-checkbox:checked').length;
                    var extraPrice = $('#extra-seat').data('price');

                    // console.log('selectedSeats ', selectedSeats);
                    // console.log('limit ', limit);
                    if (selectedSeats > limit) {
                        this.checked = false;
                    } else {
                        if ($('#extra-seat').length != 0) {
                            if ($(this).prop("checked") == true) {
                                $('#total-text').text(parseFloat($('#total-text').text()) + extraPrice);
                                $('#cart-total').val($('#total-text').text());
                                //checkAmount(parseInt($('#total-text').text()));
                                $('.total-extra-seat').removeClass('hidden')
                                if (selectedSeats <= limit) {
                                    $('#total-extra-seat').text(selectedSeats + ' ')
                                    $('#forth-total-extra-seat-price').text(parseFloat(extraPrice) * selectedSeats)
                                }
                            }
                            else if ($(this).prop("checked") == false) {
                                $('#total-text').text(parseFloat($('#total-text').text()) - extraPrice);
                                $('#cart-total').val($('#total-text').text());
                                //checkAmount(parseInt($('#total-text').text()));
                                if (selectedSeats > 0) {
                                    $('#total-extra-seat').text(selectedSeats + ' ')
                                    $('#forth-total-extra-seat-price').text(parseFloat($('#forth-total-extra-seat-price').text()) - extraPrice)
                                } else {
                                    $('.total-extra-seat').addClass('hidden')
                                }
                            }
                        }
                        // console.log('hereeeee ');
                        var price = parseFloat($('#total-text').text()),
                            seatArray = [];
                        $('.forth-seat-checkbox:checked').each(function (e) {

                            price += extraPrice;

                            seatArray.push(' ' + $(this).attr('data-seat'));
                            if ($(this).prop("checked") == true) {
                                if ($('#seats-' + e).length == 0) {
                                    $('<input>').attr({
                                        type: 'hidden',
                                        id: 'seats-' + e,
                                        name: 'passenger[' + e + '][forth_seat]',
                                        value: $(this).attr('data-seat')
                                    }).appendTo('#order-form');

                                    $('<input>').attr({
                                        type: 'hidden',
                                        id: 'seats-' + e + '-price',
                                        name: 'passenger[' + e + '][forth_seat_price]',
                                        value: $('#extra-seat').attr('data-price')
                                    }).appendTo('#order-form');
                                }
                            } else if ($(this).prop("checked") == false) {
                                $('#seats-' + e).remove()
                                $('#seats-' + e + '-price').remove()
                            }

                        });

                        $('.total-price-dollars').text(price);
                        $('.selected-seats-list').text(seatArray);
                        $('.assigned-seats-left').text(selectedSeats);
                        //checkAmount(price)

                        var seat_name = $(this).data('seat');
                        var hidden = $('input[value="' + seat_name + '"]');
                        //console.log('seat_name=> ', seat_name)
                        //console.log('hidden=> ', hidden)
                        if ($(this).prop("checked") == false) {
                            $('#' + hidden[0].id + '-price').remove()
                            $('#' + hidden[0].id).remove()
                        }
                    }
                });
            });
        } else {
            // console.log('else ');
            var limit = $('#seat-reservation-drawer').data('passengers');
            $('#limit-passengers').text(limit)
            $('#seat-reservation').click(function (e) {
                limit = $('#seat-reservation-drawer').data('passengers');
                e.preventDefault();
                var windowsize = $(window).width();
                $('#seat-reservation-drawer').addClass('is-visible');
                $('#seat-reservation-drawer').addClass('left-auto');
                $('.mdl-layout__drawer-right').addClass('is-visible');
                $('.mdl-layout__container').addClass('overflow-hidden');
                if (windowsize > 839) {
                    $('#seat-reservation-drawer').addClass('w-3/5')
                } else {
                    $('#seat-reservation-drawer').addClass('w-full')
                }
                $('#seat-reservation-drawer').removeClass('invisible')
                return false;
            });
            $('#back-btn').hide();
            $('#forth_trip').click(function () {
                $('#trip-row').hide();
                if ($('.forth_bus_layout').length == 0) {
                    $('#bus-layout').addClass('spinner');
                    $.ajax({
                        type: "get",
                        data: {
                            round_trip: 'forth'
                        },
                        url: "/order/getFleetType",
                        cache: false,
                        success: function (data) {
                            $('#bus-layout').removeClass('spinner');
                            $('#bus-layout').show();
                            if ($('.forth_bus_layout').length > 0) {
                                $('.forth_bus_layout').hide();
                                $('#bus-layout').append(data)
                            } else if ($('.back_bus_layout').length > 0) {
                                $('.back_bus_layout').hide();
                                $('#bus-layout').append(data)
                            } else {
                                $('#bus-layout').html(data)
                            }
                            $('#back-btn').show();
                        }
                    });
                } else {
                    $('.forth_bus_layout').parent().show()
                }
                $(document).ready(function () {

                    var $body = $('body');
                    // var limit = $('#seat-reservation-drawer').data('passengers');
                    //round_trip = $('#seat-reservation-drawer').data('round-trip');

                    $body.on('change', '.forth-seat-checkbox', function (e) {
                        var selectedSeats = $('.forth-seat-checkbox:checked').length;
                        var extraPrice = $('#extra-seat').data('price');
                        if ($('#extra-seat').length != 0) {
                            if ($(this).prop("checked") == true) {
                                $('#total-text').text(parseFloat($('#total-text').text()) + extraPrice);
                                $('#cart-total').val($('#total-text').text());
                                //checkAmount(parseInt($('#total-text').text()));
                                $('.total-extra-seat').removeClass('hidden')
                                if (selectedSeats <= limit) {
                                    $('#total-extra-seat').text(selectedSeats + ' ')
                                    $('#forth-total-extra-seat-price').text(parseFloat(extraPrice) * selectedSeats)
                                }
                            }
                            else if ($(this).prop("checked") == false) {
                                $('#total-text').text(parseFloat($('#total-text').text()) - extraPrice);
                                $('#cart-total').val($('#total-text').text());
                                //checkAmount(parseInt($('#total-text').text()));
                                if (selectedSeats > 0) {
                                    $('#total-extra-seat').text(selectedSeats + ' ')
                                    $('#forth-total-extra-seat-price').text(parseFloat($('#forth-total-extra-seat-price').text()) - extraPrice)
                                } else {
                                    $('.total-extra-seat').addClass('hidden')
                                }
                            }
                        }

                        if (selectedSeats > limit) {
                            this.checked = false;
                        } else {

                            var price = parseFloat($('#total-text').text()),
                                seatArray = [];

                            $('.forth-seat-checkbox:checked').each(function (e) {
                                price += extraPrice;

                                seatArray.push(' ' + $(this).attr('data-seat'));
                                if ($(this).prop("checked") == true) {
                                    if ($('#seats-' + e).length == 0) {
                                        $('<input>').attr({
                                            type: 'hidden',
                                            id: 'seats-' + e,
                                            name: 'passenger[' + e + '][forth_seat]',
                                            value: $(this).attr('data-seat')
                                        }).appendTo('#order-form');

                                        $('<input>').attr({
                                            type: 'hidden',
                                            id: 'seats-' + e + '-price',
                                            name: 'passenger[' + e + '][forth_seat_price]',
                                            value: $('#extra-seat').attr('data-price')
                                        }).appendTo('#order-form');
                                    }
                                } else if ($(this).prop("checked") == false) {
                                    $('#seats-' + e).remove()
                                    $('#seats-' + e + '-price').remove()
                                }
                            });

                            $('.total-price-dollars').text(price);
                            $('.selected-seats-list').text(seatArray);
                            $('.forth-seats-left').text(selectedSeats);
                            $('.assigned-seats-left').text(selectedSeats);

                        }
                        var seat_name = $(this).data('seat');
                        var hidden = $('input[value="' + seat_name + '"]');
                        if ($(this).prop("checked") == false) {
                            $('#' + hidden[0].id + '-price').remove()
                            $('#' + hidden[0].id).remove()
                        }
                    });
                });
            })
            $('#back_trip').click(function () {
                $('#trip-row').hide();
                if ($('back_bus_layout').length == 0) {
                    $('#bus-layout').addClass('spinner');
                    $.ajax({
                        type: "get",
                        data: {
                            round_trip: 'back'
                        },
                        url: "/order/getFleetType",
                        cache: false,
                        success: function (data) {
                            $('#bus-layout').removeClass('spinner');
                            $('#bus-layout').show();
                            if ($('.back_bus_layout').length > 0) {
                                $('.back_bus_layout').hide();
                                $('#bus-layout').append(data)
                            } else if ($('.back_bus_layout').length > 0) {
                                $('.back_bus_layout').hide();
                                $('#bus-layout').append(data)
                            } else {
                                $('#bus-layout').html(data)
                            }
                            $('#back-btn').show();
                        }
                    });
                } else {
                    $('.back_bus_layout').parent().show()
                }
                $(document).ready(function () {

                    var $body = $('body');
                    // limit = $('#seat-reservation-drawer').data('passengers');
                    //round_trip = $('#seat-reservation-drawer').data('round-trip');

                    $body.on('change', '.back-seat-checkbox', function (e) {
                        var back_selectedSeats = $('.back-seat-checkbox:checked').length;
                        var extraPrice = $('#extra-seat').data('price');
                        if ($('#extra-seat').length != 0) {
                            if ($(this).prop("checked") == true) {
                                $('#total-text').text(parseFloat($('#total-text').text()) + extraPrice);
                                $('#cart-total').val($('#total-text').text());
                                //checkAmount(parseFloat($('#total-text').text()));
                                $('.back-total-extra-seat').removeClass('hidden')
                                if (back_selectedSeats <= limit) {
                                    $('#back-total-extra-seat').text(back_selectedSeats + ' ')
                                    $('#back-total-extra-seat-price').text(parseFloat(extraPrice) * back_selectedSeats)
                                }
                            }
                            else if ($(this).prop("checked") == false) {
                                $('#total-text').text(parseFloat($('#total-text').text()) - extraPrice);
                                $('#cart-total').val($('#total-text').text());
                                //checkAmount(parseFloat($('#total-text').text()));
                                if (back_selectedSeats > 0) {
                                    $('#back-total-extra-seat').text(back_selectedSeats + ' ')
                                    $('#back-total-extra-seat-price').text(parseFloat($('#back-total-extra-seat-price').text()) - extraPrice)
                                } else {
                                    $('.back-total-extra-seat').addClass('hidden')
                                }
                            }
                        }
                        if (back_selectedSeats > limit) {
                            this.checked = false;
                        } else {

                            var price = parseFloat($('#total-text').text()),
                                seatArray = [];

                            $('.back-seat-checkbox:checked').each(function (e) {
                                price += extraPrice;
                                seatArray.push(' ' + $(this).attr('data-seat'));
                                if ($(this).prop("checked") == true) {
                                    if ($('#back-seats-' + e).length == 0) {
                                        $('<input>').attr({
                                            type: 'hidden',
                                            id: 'back-seats-' + e,
                                            name: 'passenger[' + e + '][back_seat]',
                                            value: $(this).attr('data-seat')
                                        }).appendTo('#order-form');

                                        $('<input>').attr({
                                            type: 'hidden',
                                            id: 'back-seats-' + e + '-price',
                                            name: 'passenger[' + e + '][back_seat_price]',
                                            value: $('#extra-seat').attr('data-price')
                                        }).appendTo('#order-form');
                                    }
                                } else if ($(this).prop("checked") == false) {
                                    $('#back-seats-' + e).remove()
                                    $('#back-seats-' + e + '-price').remove()
                                }
                            });

                            $('.total-price-dollars').text(price);
                            $('.selected-seats-list').text(seatArray);
                            $('.back-seats-left').text(back_selectedSeats);
                            $('.assigned-seats-left').text(back_selectedSeats);

                        }
                        var back_seat_name = $(this).data('seat');
                        var back_hidden = $('input[value="' + back_seat_name + '"]');
                        if ($(this).prop("checked") == false) {
                            $('#' + back_hidden[0].id + '-price').remove()
                            $('#' + back_hidden[0].id).remove()
                        }
                    });
                });
            })
            $('#back-btn').click(function () {
                $('#bus-layout').hide();
                $('#trip-row').show();
            })
        }



        function CheckRequired(event) {
            var ret = true;

            $(".required").each(function () {
                var check = $(this).val();

                if (check == '') {
                    ret = false;
                    $(this).addClass('border-red');
                    if ($(this).attr('placeholder') == 'Gender') {
                        $(this).parent().addClass('border-red');
                    }
                }
            });

            if (!ret) {
                return 'unvalid';
            } else {
                return 'valid';
            }
        }
        $(".required").on("input", function () {
            var check = $(this).val();
            // console.log('changed => ', check);
            if (check != '') {
                $(this).removeClass('border-red');
                if ($(this).attr('placeholder') == 'Gender') {
                    $(this).parent().removeClass('border-red');
                }
            }
        })
        // checkInputs();
        //PAY WITH SADAD
        $('#pay-with-sadad').click(function (params) {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"]; // Remove header before call
            $.ajax({
                url: "https://hutils.loxal.net/whois",
                type: 'GET',
                success: function(data) {
                    var default_currency = $("#default-currency").text();
                    var current_currency = $("#current-currency").text();
                    // if(default_currency == current_currency) {
                    // if (data?.country?.includes("Libya") || data?.countryIso?.includes('LBY')) {
                    $("<input>")
                        .attr({
                            type: "hidden",
                            name: "action",
                            value: "sadad-payment",
                        })
                        .appendTo("#actions");
                    var values = {};
                    var validation = CheckRequired($("#order-form"));
                    $.each(
                        $("#order-form").serializeArray(),
                        function (i, field) {
                            values[field.name] = field.value;
                        }
                    );
                    //console.log('checkbox', $('#booking_policies').prop("checked"))
                    if (
                        validation == "valid" &&
                        $("#booking_policies").prop("checked")
                    ) {
                        //console.log(values);
                        $(this).addClass("text-dark-blue");
                        $(this).removeClass("bg-blue");
                        $(this).removeClass("text-white");
                        $(this).addClass("bg-dark-blue");
                        $(this).addClass("white-spinner");
                        $(this).addClass("cursor-not-allowed");
                        $.ajax({
                            url: "/order/sadad/payment",
                            type: "post",
                            data: values,
                            success: function (resp) {
                                console.log("data => ", resp);
                                $(this).removeClass("text-dark-blue");
                                $(this).addClass("bg-blue");
                                $(this).addClass("text-white");
                                $(this).removeClass("bg-dark-blue");
                                $(this).removeClass("white-spinner");
                                $(this).removeClass("cursor-not-allowed");
                                window.location.replace(resp);
                            },
                            error: function (xhr) {
                                console.log("error => ", xhr);
                                $("#pay-with-sadad").removeClass(
                                    "bg-dark-blue"
                                );
                                $("#pay-with-sadad").removeClass(
                                    "white-spinner"
                                );
                                $("#pay-with-sadad").removeClass(
                                    "cursor-not-allowed"
                                );
                                $("#pay-with-sadad").removeClass(
                                    "text-dark-blue"
                                );
                                $("#pay-with-sadad").addClass("bg-blue");
                                $("#pay-with-sadad").addClass("text-white");
                            },
                        });
                        return false;
                    }
                    // }else {
                    //     Swal.fire({
                    //         title: $("#sadad-text").text(),
                    //         icon: 'warning',
                    //         confirmButtonText: $("#sadad-text-cancel").text(),
                    //     }).then((result) => {

                    //     })

                    // }
                    /* }else {
                    Swal.fire({
                        title: $("#sadad-payment-warning").text(),
                        icon: 'warning',
                        confirmButtonText: $("#sadad-text-cancel").text(),
                    }).then((result) => {
                        
                    })

                }*/
                },
                error: function(err) {
                    console.log("Request failed, error= " + err);
                }
            });
            
        })
        // Apply Coupon
        $('#coupon').on('input', function (e) {
            var check = $(this).val();
            if (check == '') {
                $(this).addClass('border-red');
            } else {
                $(this).removeClass('border-red');
                $("#apply-coupon").unbind()
            }
        })
        $('body').on('click', '#apply-coupon', function (e) {
            var cart_total = parseFloat($('#total-text').text())
            var code = $('#coupon').val();
            if (code == "") {
                $('#coupon').addClass('border-red');
                e.preventDefault()
            } else {
                $(this).addClass('text-dark-blue')
                $(this).removeClass('bg-blue')
                $(this).removeClass('text-white')
                $(this).addClass('bg-dark-blue')
                $(this).addClass('white-spinner')
                $(this).addClass('cursor-not-allowed')
                $(this).prop('disabled', true)

                $.ajax({
                    url: '/order/coupon',
                    type: "post",
                    data: {
                        'code': code,
                        'total': cart_total
                    },
                    success: function (data) {
                        $("#apply-coupon").removeClass('text-dark-blue')
                        $("#apply-coupon").addClass('bg-blue')
                        $("#apply-coupon").addClass('text-white')
                        $("#apply-coupon").removeClass('bg-dark-blue')
                        $("#apply-coupon").removeClass('white-spinner')
                        $("#apply-coupon").removeClass('cursor-not-allowed')
                        $("#apply-coupon").prop('disabled', false)
                        $("#apply-coupon").addClass('hidden')
                        $("#remove-code").removeClass('hidden')
                        if ($('#error-message').length > 0) {
                            $('#error-message').remove();
                        }
                        var coupon_discount = 0;
                        coupon_discount = (data?.discount_amount || 0);
                        $("#remove-code").attr('data-discount-amount', coupon_discount);
                        if (parseInt($('#total-text').text()) > 0) {
                            $('#total-text').text(parseFloat($('#total-text').text()) - coupon_discount)
                            $('#cart-total').val($('#total-text').text());
                        }
                        $('<input>').attr({
                            type: 'hidden',
                            id: 'coupon-code',
                            name: 'coupon',
                            value: code
                        }).appendTo('#order-form');
                    },
                    error: function (resultat, statut, erreur) {
                        $("#apply-coupon").removeClass('text-dark-blue')
                        $("#apply-coupon").addClass('bg-blue')
                        $("#apply-coupon").addClass('text-white')
                        $("#apply-coupon").removeClass('bg-dark-blue')
                        $("#apply-coupon").removeClass('white-spinner')
                        $("#apply-coupon").removeClass('cursor-not-allowed')
                        $("#apply-coupon").prop('disabled', false)
                        $('#coupon-row').append('<p id="error-message" class="text-red">' + resultat.responseJSON.error + '</p>')
                    }
                })
            }
        })

        //Remove Coupon
        $('body').on('click', '#remove-code', function () {
            var discount_amount = $(this).data('discount-amount');
            $('#coupon').val('');
            $('#total-text').text(parseInt($('#total-text').text()) + discount_amount)
            $('#cart-total').val($('#total-text').text());
            $(this).addClass('hidden')
            $("#apply-coupon").removeClass('hidden')
            $("#coupon-code").remove()
        })
    }
})
